import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  annualSalary: 100000,
  monthlyContribution: 10,
  currentAge: 30,
  retirementAge: 65,
  returnRate: 7,
  currentBalance: 5000,
  employerMatch: 20,
  salaryLimit: 6,
  monthsToRetirement: 0,
  errors: null,
  estimatedReturn: 7,
  calculationResults: null
};

const contributionSlice = createSlice({
  name: 'contributionCalculator',
  initialState,
  reducers: {
    setAnnualSalary: (state, action) => {
      state.annualSalary = action.payload;
    },
    setEstimatedReturn: (state, action) => {
      state.estimatedReturn = action.payload;
    },
    setMonthlyContribution: (state, action) => {
      state.monthlyContribution = action.payload;
    },

    setCurrentAge: (state, action) => {
      state.currentAge = action.payload;
    },
    setRetirementAge: (state, action) => {
      state.retirementAge = action.payload;
    },
    setReturnRate: (state, action) => {
      state.returnRate = action.payload;
    },
    setCurrentBalance: (state, action) => {
      state.currentBalance = action.payload;
    },
    setEmployerMatch: (state, action) => {
      state.employerMatch = action.payload;
    },
    setSalaryLimit: (state, action) => {
      state.salaryLimit = action.payload;
    },
    setErrors: (state, action) => {
      state.errors = action.payload;
    },
    setMonthlyRate: (state, action) => {
      state.monthlyRate = action.payload;
    },
    setCalculationResults: (state, action) => {
      state.calculationResults = action.payload;
    },
    resetContributionData: (state) => {
      return initialState;
    },

  }
});

export const {
  setAnnualSalary,
  setMonthlyContribution,
  setMonthlyRate,
  setCurrentAge,
  setRetirementAge,
  setReturnRate,
  setCurrentBalance,
  setEmployerMatch,
  setSalaryLimit,
  setErrors,
  setEstimatedReturn, setCalculationResults, resetContributionData
} = contributionSlice.actions;

export default contributionSlice.reducer;
export const { setActiveCalculator } = contributionSlice.actions;
